import {
  DomainName,
  IFormInputControl,
  TControlName,
} from '@infotech-soe/metaschema';

import CachedSchemaRepository from '../../../../../infrastructure/schemas/storage/CachedSchemaRepository';
import { NamedDomain } from '../../../../../infrastructure/schemas/storage/NamedDomain';
import { FormSource, FormSourceType } from '../../../view-model/FormSource';

export const controlDomain = async (
  item: IFormInputControl,
  source: FormSource,
  domains: Array<{ name: TControlName; domain: DomainName }> = []
): Promise<NamedDomain> => {
  const schemaRepository = new CachedSchemaRepository();
  let domainName = await (async () => {
    if (
      source.type === FormSourceType.FORM ||
      source.type === FormSourceType.REVIEW ||
      source.type === FormSourceType.PRINT
    ) {
      const fields = await schemaRepository.getCategoryActionDomains(
        source.category,
        source.action
      );

      if (fields[item.name]) {
        return fields[item.name];
      }
    }
  })();

  if (!domainName) {
    const dynamicField = domains.find(({ name }) => name === item.name);

    if (dynamicField) {
      domainName = dynamicField.domain;
    }
  }

  if (!domainName) {
    throw new Error(`can not detect domain for ${item.name}`);
  }

  return schemaRepository.getDomain(domainName);
};
